import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import { z } from 'zod';
import { useCart } from '~/composables/useCart';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useFeatureFlagTalonOne } from '~/composables/_next/useFeatureFlagTalonOne';
import GiftCartDiscount from '~/models/gift-cart-discount';
var schemaShippingMethodCostDiscount = z.optional(z.object({
  type: z.enum(['percent']),
  value: z.coerce.number()
}));
export function useShippingMethods() {
  var _useNuxt2App = useNuxt2App(),
    $sentry = _useNuxt2App.$sentry;
  var _useCart = useCart(),
    cart = _useCart.cart,
    totalPriceItems = _useCart.totalPriceItems,
    freeShippingCoupons = _useCart.freeShippingCoupons;
  var _useFeatureFlagTalonO = useFeatureFlagTalonOne(),
    isTalonOneEnabled = _useFeatureFlagTalonO.isTalonOneEnabled;
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var shippingMethods = useState("shipping-methods", function () {
    return [];
  });
  var shippingMethodsWithPrice = computed(function () {
    var methods = _toConsumableArray(shippingMethods.value);
    methods.sort(function (a, b) {
      var _a$custom, _a$custom$customField, _a$custom$customField2, _b$custom, _b$custom$customField, _b$custom$customField2;
      var orderA = (_a$custom = a.custom) === null || _a$custom === void 0 ? void 0 : (_a$custom$customField = _a$custom.customFieldsRaw) === null || _a$custom$customField === void 0 ? void 0 : (_a$custom$customField2 = _a$custom$customField.find(function (field) {
        return field.name === 'display-order';
      })) === null || _a$custom$customField2 === void 0 ? void 0 : _a$custom$customField2.value;
      var orderB = (_b$custom = b.custom) === null || _b$custom === void 0 ? void 0 : (_b$custom$customField = _b$custom.customFieldsRaw) === null || _b$custom$customField === void 0 ? void 0 : (_b$custom$customField2 = _b$custom$customField.find(function (field) {
        return field.name === 'display-order';
      })) === null || _b$custom$customField2 === void 0 ? void 0 : _b$custom$customField2.value;
      return orderA - orderB;
    });
    return methods.map(function (method) {
      return _objectSpread(_objectSpread({}, method), {}, {
        price: getShippingMethodPrice(method)
      });
    });
  });
  var cheapestShippingMethod = computed(function () {
    return _toConsumableArray(shippingMethodsWithPrice.value).filter(function (method) {
      return method.key !== 'store-pick-up';
    }).sort(function (a, b) {
      return a.price.regular - b.price.regular;
    })[0];
  });
  function loadShippingMethods(_x) {
    return _loadShippingMethods.apply(this, arguments);
  }
  function _loadShippingMethods() {
    _loadShippingMethods = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(cartId) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.cart.getShippingMethods.query({
              cartId: cartId
            });
          case 2:
            shippingMethods.value = _context.sent;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _loadShippingMethods.apply(this, arguments);
  }
  function getShippingMethodPrice(shippingMethod) {
    var _shippingMethod$zoneR, _zoneRate$shippingRat, _zoneRate$shippingRat2, _zoneRate$shippingRat3, _zoneRate$shippingRat4, _zoneRate$shippingRat5;
    var totalPrice = totalPriceItems.value;
    var zoneRate = (_shippingMethod$zoneR = shippingMethod.zoneRates) === null || _shippingMethod$zoneR === void 0 ? void 0 : _shippingMethod$zoneR.filter(function (zone) {
      var _zone$shippingRates$;
      return (_zone$shippingRates$ = zone.shippingRates[0]) === null || _zone$shippingRates$ === void 0 ? void 0 : _zone$shippingRates$.isMatching;
    })[0];
    var freeAboveCentAmount = zoneRate === null || zoneRate === void 0 ? void 0 : (_zoneRate$shippingRat = zoneRate.shippingRates[0]) === null || _zoneRate$shippingRat === void 0 ? void 0 : (_zoneRate$shippingRat2 = _zoneRate$shippingRat.freeAbove) === null || _zoneRate$shippingRat2 === void 0 ? void 0 : _zoneRate$shippingRat2.centAmount;
    var priceShipping = (_zoneRate$shippingRat3 = zoneRate === null || zoneRate === void 0 ? void 0 : (_zoneRate$shippingRat4 = zoneRate.shippingRates[0]) === null || _zoneRate$shippingRat4 === void 0 ? void 0 : (_zoneRate$shippingRat5 = _zoneRate$shippingRat4.price) === null || _zoneRate$shippingRat5 === void 0 ? void 0 : _zoneRate$shippingRat5.centAmount) !== null && _zoneRate$shippingRat3 !== void 0 ? _zoneRate$shippingRat3 : 0;
    if (!priceShipping || freeAboveCentAmount && Math.round(totalPrice * 100) / 100 >= freeAboveCentAmount / 100) {
      return {
        regular: 0,
        special: 0
      };
    }
    var priceShippingWithDiscount = null;
    try {
      var _cart$value, _cart$value$custom, _cart$value$custom$cu, _discountCustomField$;
      var discountCustomField = (_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : (_cart$value$custom = _cart$value.custom) === null || _cart$value$custom === void 0 ? void 0 : (_cart$value$custom$cu = _cart$value$custom.customFieldsRaw) === null || _cart$value$custom$cu === void 0 ? void 0 : _cart$value$custom$cu.find(function (_ref) {
        var name = _ref.name;
        return name === 'talon_one_cart_shipping_cost_discount';
      });
      var discountValue = (_discountCustomField$ = discountCustomField === null || discountCustomField === void 0 ? void 0 : discountCustomField.value) !== null && _discountCustomField$ !== void 0 ? _discountCustomField$ : null;
      if (discountValue) {
        var _JSON$parse, _schemaShippingMethod;
        var shippingMethodCostDiscount = (_JSON$parse = JSON.parse(discountValue)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse[shippingMethod.name];
        var res = (_schemaShippingMethod = schemaShippingMethodCostDiscount.parse(shippingMethodCostDiscount)) !== null && _schemaShippingMethod !== void 0 ? _schemaShippingMethod : null;
        if (res !== null && res !== void 0 && res.value) {
          switch (res === null || res === void 0 ? void 0 : res.type) {
            case 'percent':
              priceShippingWithDiscount = priceShipping - priceShipping * (res.value / 100);
              break;
          }
        }
      }
    } catch (error) {
      console.error(error);
      $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('shippingMethod', shippingMethod);
      $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(error);
    }
    return {
      regular: priceShipping / 100,
      special: priceShippingWithDiscount !== null ? priceShippingWithDiscount / 100 : null
    };
  }
  function getShippingFreeAboveRate() {
    return _getShippingFreeAboveRate.apply(this, arguments);
  }
  function _getShippingFreeAboveRate() {
    _getShippingFreeAboveRate = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _cart$value3, _cart$value3$shipping, _shippingMethods$valu;
      var EUR_TO_CENT_RATIO, shippingFreeAboveRateForGift, giftDiscount, cartCountry, res, standardOrExpressMethod, desiredMethod, _zone$shippingRates, zone, _cart$value4, _cart$value4$shipping, _cart$value4$shipping2, zoneFreeAboveRate;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            EUR_TO_CENT_RATIO = 100;
            giftDiscount = null;
            cartCountry = (_cart$value3 = cart.value) === null || _cart$value3 === void 0 ? void 0 : (_cart$value3$shipping = _cart$value3.shippingAddress) === null || _cart$value3$shipping === void 0 ? void 0 : _cart$value3$shipping.country;
            _context2.prev = 3;
            _context2.next = 6;
            return client.cart.getCartDiscountByKey.query();
          case 6:
            res = _context2.sent;
            giftDiscount = GiftCartDiscount.fromQueryResult(res);
            _context2.next = 12;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](3);
          case 12:
            if (giftDiscount && giftDiscount.isValid() && giftDiscount.getCountryCodesFromPredicate().includes(cartCountry)) {
              shippingFreeAboveRateForGift = {
                key: 'gift_1000',
                // TODO: when we will handle others currencies than EUR, remember to update this
                centAmount: giftDiscount.getCeilingPriceFromPredicate() * EUR_TO_CENT_RATIO,
                currencyCode: giftDiscount.getCeilingCurrencyFromPredicate(),
                country: giftDiscount.getCountryCodesFromPredicate()[0]
              };
            }
            if (!((_shippingMethods$valu = shippingMethods.value) !== null && _shippingMethods$valu !== void 0 && _shippingMethods$valu.length)) {
              _context2.next = 21;
              break;
            }
            standardOrExpressMethod = shippingMethods.value.filter(function (item) {
              return item.key === 'standard' || item.key === 'express';
            });
            desiredMethod = standardOrExpressMethod.find(function (item) {
              return item.key === 'standard';
            }) || standardOrExpressMethod[0];
            if (!(desiredMethod !== null && desiredMethod !== void 0 && desiredMethod.id)) {
              _context2.next = 21;
              break;
            }
            zone = desiredMethod.zoneRates.find(function (zoneRate) {
              return zoneRate.shippingRates.some(function (item) {
                return item.isMatching;
              });
            });
            if (!(zone !== null && zone !== void 0 && (_zone$shippingRates = zone.shippingRates) !== null && _zone$shippingRates !== void 0 && _zone$shippingRates.length)) {
              _context2.next = 21;
              break;
            }
            zoneFreeAboveRate = zone.shippingRates[0].freeAbove;
            return _context2.abrupt("return", {
              shippingFreeAboveRateForGift: shippingFreeAboveRateForGift,
              shippingFreeAboveRate: {
                centAmount: zoneFreeAboveRate.centAmount,
                currencyCode: zoneFreeAboveRate.currencyCode,
                type: zoneFreeAboveRate.type,
                key: 'freeAboveRate',
                country: ((_cart$value4 = cart.value) === null || _cart$value4 === void 0 ? void 0 : (_cart$value4$shipping = _cart$value4.shippingAddress) === null || _cart$value4$shipping === void 0 ? void 0 : (_cart$value4$shipping2 = _cart$value4$shipping.country) === null || _cart$value4$shipping2 === void 0 ? void 0 : _cart$value4$shipping2.toLowerCase()) || null
              }
            });
          case 21:
            return _context2.abrupt("return", {});
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 10]]);
    }));
    return _getShippingFreeAboveRate.apply(this, arguments);
  }
  var isFreeShippingEnabled = computed(function () {
    var _cart$value2, _cart$value2$shipping;
    var shippingMethod = (_cart$value2 = cart.value) === null || _cart$value2 === void 0 ? void 0 : (_cart$value2$shipping = _cart$value2.shippingInfo) === null || _cart$value2$shipping === void 0 ? void 0 : _cart$value2$shipping.shippingMethod;
    if (isTalonOneEnabled.value) {
      var shippingMethodName = shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.name;
      var selectedShippingMethod = shippingMethodsWithPrice.value.find(function (method) {
        return method.name === shippingMethodName;
      });
      if (selectedShippingMethod) {
        return selectedShippingMethod.price.special === 0;
      }
      return false;
    } else {
      var hasFreeShippingCoupons = !!freeShippingCoupons.value.length;
      var hasStandardDelivery = shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.key.startsWith('standard');
      var hasShipping = !!(shippingMethod !== null && shippingMethod !== void 0 && shippingMethod.key);
      return hasFreeShippingCoupons && !hasShipping || hasFreeShippingCoupons && hasStandardDelivery;
    }
  });
  return {
    shippingMethods: shippingMethodsWithPrice,
    cheapestShippingMethod: cheapestShippingMethod,
    loadShippingMethods: loadShippingMethods,
    getShippingMethodPrice: getShippingMethodPrice,
    getShippingFreeAboveRate: getShippingFreeAboveRate,
    isFreeShippingEnabled: isFreeShippingEnabled
  };
}